import ResetClick from "./reset-click";
import { newsletter_signup_call} from "./gewobag-newsletter";

(function() {
	'use strict';

	/*
	* Todo: Check Usage of ":indeterminate". see here https://css-tricks.com/almanac/selectors/i/indeterminate/
	*  for Form multiple Checkbox functions
	*
	* 1. Accessible Menu
	* 2. Slider
	* 3. Reload Button
	* 4. Service Dialog
	* 5. Form Options Dialog
	* 6. Tab Navigation
	* 7. Search Functions
	* 8. Scrolling
	* 9. Newsletter Form
	* 10. Location Disclaimer // moved to es-module
	* 11. Investor Relation
	* 12. Comments
	* 13. Cookie Functions
	* 14. Overview Map
	* 15. Functions
	*/

	jQuery(document).ready(function () {

		/* 1. Accessible Menu */
		jQuery("#site-navigation").accessibleMegaMenu();

		/* 2. Slider */
		jQuery('.image-slider-section, .teaser-slider-section').each(function () {

			// Selector
			let sliderName = jQuery(this).children('ul').attr('id');
			let sliderLoop = (typeof jQuery(this).data('loop') !== 'undefined' ? jQuery(this).data('loop') : true);

			var slider = jQuery('#' + sliderName).lightSlider({
				slideMargin: (jQuery(this).hasClass('image-slider-section') ? 0 : 100),
				addClass: sliderName,
				loop: sliderLoop,
				onBeforeSlide: function (el) {
					jQuery('#current-slide-' + sliderName).text(el.getCurrentSlideCount());
				}
			});

			jQuery(window).resize(function() {
				// Todo: make it work better
				slider.css('height', slider.find('.lslide').first().find('.element-media, .teaser-element-container').outerHeight(true));
			});

		});

		/* 3. Reload Button */
		const loadMore = jQuery('#load-more-entries');

		// Load More Posts
		loadMore.on('click', function () {

			if (jQuery(this).hasClass('loading')) {
				return;
			}

			jQuery(this).removeClass('load_more').addClass('loading').html('l&auml;dt ...');

			var target = jQuery('.' + jQuery(this).data('target'));
			var reload = jQuery(this).data('reload');
			var offset = jQuery(this).data('offset');

			jQuery.ajax({
				type: 'post',
				context: this,
				dataType: 'json',
				url: jQuery(this).data('action'),
				data: {
					action: 'load_more',
					post_type: jQuery(this).data('type'),
					nonce: jQuery(this).data('nonce'),
					target: jQuery(this).data('target'),
					posts_per_page: reload,
					offset: offset,
					filter: jQuery(this).data('tax'),
					terms: jQuery(this).data('terms'),
					layout: jQuery(this).data('layout')
				},
				success: function (data) {
					if (data.have_posts === true) {
						jQuery(this).removeClass('loading').addClass('load-more');
						target.append(data.html);
					} else {
						jQuery(this).removeClass('loading load-more').addClass('end-of-posts');
					}
					jQuery(this).data('offset', offset + reload);
					jQuery(this).html(data.status);
				}
			});
		});

		/* 4. Service Dialog */
		const serviceButton = document.getElementById('service-dialog-button');

		if (serviceButton) {
			const initialServiceButtonText = serviceButton.innerHTML;
			const serviceDialog = document.getElementById('service-dialog');
			const serviceLinks = document.querySelectorAll('.service-contact-link') || [];

			serviceButton.addEventListener('click', () => {
				if (serviceButton.classList.contains('opened-service')) {
					serviceDialog.close();
					serviceButton.innerHTML = initialServiceButtonText;
				} else {
					if (typeof _paq !== 'undefined') {
						_paq.push(['trackEvent', 'CTA', 'Clicked', 'Service Box']);
					}
					serviceDialog.show();
					serviceButton.innerHTML = "Schließen";
				}
				serviceButton.classList.toggle('opened-service')
			})

			serviceLinks.forEach((item, index) => {
				item.addEventListener('click', () => {
					if (typeof _paq !== 'undefined') {
						_paq.push(['trackEvent', 'CTA', 'Clicked', 'SB ' + item.dataset.service]);
					}
				})
			});
		}

		/* 5. Form Options Dialog */
		const formDialogButtons = document.querySelectorAll('.form-options-dialog-button') || [];

		formDialogButtons.forEach((dialogButton) => {

			const formDialog = document.getElementById(dialogButton.dataset.dialog);
			const formDialogClose = formDialog.querySelector('.dialog-close');

			const dialogSelections = formDialog.querySelectorAll('input.selectable-option') || [];
			const dialogMultiSelect = formDialog.querySelector('input.all-options') || null;
			const groupMultiSelections = formDialog.querySelectorAll('input.selectable-group-option') || null;

			multiSelectCheck(dialogSelections, dialogMultiSelect, dialogButton);

			dialogSelections.forEach((item) => {
				item.addEventListener('click', () => {
					if (dialogMultiSelect.checked) {
						dialogMultiSelect.checked = false;
					}
					multiSelectCheck(dialogSelections, dialogMultiSelect, dialogButton);
				});
			});

			dialogMultiSelect.addEventListener('click', () => {
				dialogSelections.forEach((item) => {
					item.checked = dialogMultiSelect.checked;
				});
				selectedElements(dialogMultiSelect, dialogButton, true);
			});

			groupMultiSelections.forEach((item) => {
				const groupElements = item.closest('.selection-group').querySelectorAll('input:not(.selectable-group-option)');

				item.addEventListener('click', () => {
					groupElements.forEach((child) => {
						child.checked = item.checked;
					});
				});
			});

			dialogButton.addEventListener('click', (e) => {
				e.preventDefault();

				if (dialogButton.classList.contains('opened-form-options')) {
					formDialog.close();
				} else {
					formDialog.show();
				}

				dialogButton.classList.toggle('opened-form-options')
			});

			formDialogClose.addEventListener('click', (e) => {
				e.preventDefault();

				formDialog.close();
				dialogButton.classList.remove('opened-form-options')
			});

			const resetClickCallback = (dialogButton, formDialog) => {
				if (dialogButton.classList.contains('opened-form-options')) {
					formDialog.close();
					dialogButton.classList.toggle('opened-form-options');
				}
			}

			new ResetClick([formDialog, dialogButton], () => {
				resetClickCallback(dialogButton, formDialog);
			});
		});

		/* 5.1 Share Sheet Dialog */
		document.querySelectorAll('.js-gw-share-sheet').forEach((shareSheet) => {
			const trigger = shareSheet.querySelector('.js-gw-share-sheet__trigger');
			const dialogElement = shareSheet.querySelector('.js-gw-share-sheet__dialog');
			const closeButton = shareSheet.querySelector('.js-gw-share-sheet__close');
			const copyButton = shareSheet.querySelector('.js-gw-share-sheet__copy');
			const copyInput = shareSheet.querySelector('.js-gw-share-sheet__input');
			const copyIcon = shareSheet.querySelector('.js-gw-share-sheet__copy');
			const copiedIcon = shareSheet.querySelector('.js-gw-share-sheet__copied');
			const dialog = dialogElement;

			const toggleIcon = (isCopied) => {
				if (isCopied) {
					copyIcon.style.display = 'none';
					copiedIcon.style.display = 'flex';
				} else {
					copyIcon.style.display = 'flex';
					copiedIcon.style.display = 'none';
				}
			};

			copiedIcon.style.display = 'none';

			if (!trigger || !dialog) {
				return;
			}

			const closeDialog = () => {
				if (dialog.open) {
					dialog.close();
					toggleIcon(false);
				}
			};

			trigger.addEventListener('click', (event) => {
				event.preventDefault();

				if (typeof dialog.showModal === 'function') {
					dialog.showModal();
					toggleIcon(false);
					return;
				}

				alert('Dialog-Fenster werden von diesem Browser nicht unterstuetzt.');
			});

			if (closeButton) {
				closeButton.addEventListener('click', (event) => {
					event.preventDefault();
					closeDialog();
				});
			}

			dialogElement.addEventListener('click', (event) => {
				const bounds = dialog.getBoundingClientRect();
				const isInDialog =
					event.clientX >= bounds.left &&
					event.clientX <= bounds.right &&
					event.clientY >= bounds.top &&
					event.clientY <= bounds.bottom;

				if (!isInDialog) {
					closeDialog();
				}
			});

			if (copyButton && copyInput) {
				copyButton.addEventListener('click', async (event) => {
					event.preventDefault();

					try {
						if (navigator.clipboard && navigator.clipboard.writeText) {
							await navigator.clipboard.writeText(copyInput.textContent);
						} else {
							document.execCommand('copy');
						}

						toggleIcon(true);

						window.setTimeout(() => {
							toggleIcon(false);
						}, 1500);
					} catch (error) {
						toggleIcon(false);
					}
				});
			}
		});

		const rentalForm = document.getElementById('rental-form');
		const sortBySelect = document.getElementById('results-sort-by');

		if (rentalForm && sortBySelect) {
			sortBySelect.addEventListener('change', function () {
				document.getElementById('sort-by-hidden').value = this.value;
				rentalForm.children[0].submit();
			});
		}

		/* 6. Tab Navigation */
		if (jQuery('#content-tabs').length !== 0) {

			var tabSelect = jQuery('.content-tabs-buttons button');
			var tabContent = jQuery('.content-tab');
			var contactDetails = jQuery('.contact-area-details');

			tabSelect.click(function () {
				let selectedID = jQuery(this).data('tab');
				anchor_scroll('#tabs-content', 300);
				tabSelect.each(function () {
					jQuery(this).removeClass('tab-select-active');
				});
				tabContent.each(function () {
					jQuery(this).removeClass('tab-content-active');
				});
				jQuery(this).addClass('tab-select-active');
				jQuery('#' + selectedID).addClass('tab-content-active');

				if(selectedID === 'rental-contact') {
					iframeSizing('#contact-iframe');
					contactDetails.hide();
				} else {
					contactDetails.show();
				}

			});

		}

		/* 7. Search Functions */
		const searchList = jQuery('#search-list');
		var filterCheckbox = jQuery('.smart-tag-check');

		filterCheckbox.click(function () {
			let filterID = jQuery(this).attr('id');

			if(jQuery(this).prop("checked") === false) {
				jQuery(searchList).children('article').each(function () {
					if(jQuery(this).hasClass('search-' + filterID)) {
						jQuery(this).addClass('type-hide');
					}
				});
			} else {
				jQuery(searchList).children('article').each(function () {
					if(jQuery(this).hasClass('search-' + filterID)) {
						jQuery(this).removeClass('type-hide');
					}
				});
			}
		});

		/* 8. Scrolling */
		jQuery('#scroll-up').click(function () {
			jQuery('html, body').animate({
				scrollTop: 0
			}, 800);
			jQuery('#masthead a').first().focus();
		});

		var scrollPos = jQuery(window).scrollTop();
		const header = jQuery('#masthead');

		jQuery(window).scroll(function () {

			var scroll = jQuery(window).scrollTop();

			if (scroll <= 350) {
				jQuery('#scroll-up').removeClass('show-scroll-up');
			} else {
				jQuery('#scroll-up').addClass('show-scroll-up');
			}

			if (scroll > scrollPos && scroll > 50) {
				header.addClass('shrinked-header');
			} else if (scroll < scrollPos) {
				header.removeClass('shrinked-header');
			}

			scrollPos = scroll;

		});

		if (window.location.hash) {
			anchor_scroll(window.location.hash, 150);
			setTimeout(function() {
				header.addClass('shrinked-header');
			}, 550);
		}

		// Todo: Exclude Menu Navigation
		document.querySelectorAll('a[href^="#"]').forEach(link => {
			link.addEventListener('click', function (e) {
				const url = this.getAttribute('href');
				if (url !== '#' && document.querySelector(url)) {
					e.preventDefault();
					const masthead = document.getElementById('masthead');
					const offsetTop = masthead.getBoundingClientRect().bottom;
					anchor_scroll(url, offsetTop);
					setTimeout(function () {
						masthead.classList.add('shrinked-header');
					}, 550);
				}
			});
		});

		jQuery(".show-form-mobile").click(function () {

			jQuery(this).slideUp(100).siblings(".form-info, .login-form, .form-addition").slideDown(300);

		});

		/* 9. Newsletter Form */
		jQuery('.newsletter-signup-section').each(function() {

			var formContainer = jQuery('#'+ jQuery(this).children('.signup-form').attr('id'));
			var nlForm = formContainer.find('#newsletter-form');
			var nlButton = formContainer.find('#button-control');

			nlButton.on('click', function (event) {

				event.preventDefault();

				newsletter_signup_call(nlForm, formContainer);

			});

		});

		/* Todo: Combine with NL Function above */
		jQuery('.newsletter-form-block').each(function() {

			var formContainer = jQuery('#'+ jQuery(this).children('.signup-form').attr('id'));
			var nlForm = formContainer.find('#newsletter-form');
			var nlButton = formContainer.find('#button-control');

			nlButton.on('click', function (event) {

				event.preventDefault();

				newsletter_signup_call(nlForm, formContainer);

			});

		});

		/* 9.2. New Newsletter Form (gw-nl-signup) */
		document.querySelectorAll('.js-gw-nl-signup').forEach((element) => {
			const container = element;
			const main = container.querySelector('.js-gw-nl-signup__main');
			const form = container.querySelector('.js-gw-nl-signup__form');
			const submitButton = container.querySelector('.js-gw-nl-signup__submit');

			submitButton.addEventListener('click', (event) => {
				event.preventDefault();
				newsletter_signup_call(jQuery(form), jQuery(main), false);
			});
		});

		/* 11. Investor Relation */
		const investorContainer = jQuery('#investor-relation-container');

		if (investorContainer.length !== 0) {

			jQuery.ajax({
				url: jQuery('#investor-url').val(),
				type: 'POST',
				data: {
					action: 'investor_get_articles',
					investor_nonce: jQuery('#investor-nonce').val(),
				},
				dataType: 'json',
				beforeSend: function () {
					investorContainer.addClass('load-investor-articles');
				},
				error: function () {
					investorContainer.removeClass('load-investor-articles')
						.addClass('articles-error');
				},
				success: function (data) {

					investorContainer.removeClass('load-investor-articles')
						.addClass('articles-success')
						.html(data.html);
				}
			});

			return false;

		}

		/* 12. Comments */
		jQuery('.comment-form').submit(function() {

			var commentForm = jQuery('.comment-form');
			var comment = jQuery(commentForm).find('#comment');

			if (comment.val().length > 0) {

				return true;

			} else {

				var submit = jQuery(commentForm).find('#submit');
				jQuery(submit).addClass('error');

				var errorMessage = __( 'Bitte dieses Feld ausfüllen', 'gewo-forms' );
				errorMessage = '<div class="error-message">' + errorMessage + '</div>';

				jQuery(commentForm).find('.error-message').remove();

				jQuery(comment)
					.change(function() {
						jQuery(commentForm).find('.error-message').remove();
						jQuery(submit).removeClass('error');
					})
					.after(errorMessage);

				return false;
			}
		});

		/* 13. Cookie Functions */
		window.setCookie = function (cname, cvalue, exdays = 0) {
			var expires = "";
			if (exdays !== 0) {
				var d = new Date();
				d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
				expires = "expires=" + d.toUTCString() + ";";
			}
			document.cookie = cname + "=" + cvalue + ";" + expires + "path=/;SameSite=Strict;secure";
		}

		window.getCookie = function (cname) {
			var name = cname + "=";
			var decodedCookie = decodeURIComponent(document.cookie);
			var ca = decodedCookie.split(';');
			for (var i = 0; i < ca.length; i++) {
				var c = ca[i];
				while (c.charAt(0) == ' ') {
					c = c.substring(1);
				}
				if (c.indexOf(name) == 0) {
					return c.substring(name.length, c.length);
				}
			}
			return "";
		}

		// Check for WH Form Success
		window.addEventListener("message", (event) => {
			let jsonData = JSON.parse(event.data, (key, value) => {
				if (key === 'type' && value === 'WH_APPLICATION_FORM_FILLED_SUCCESSFULLY') {
					window.location.href = location.protocol + '//' + location.hostname + "/daten-uebermittelt/?mtm_campaign=erstanfrage&mtm_source=whelden";
				}
			});
		}, false);


		/* 14. Overview Map */

		const selectionGroups = document.querySelectorAll('.js-selection-group');

		selectionGroups.forEach(function (group) {
			const children = Array.from(group.children);
			const firstChild = children[0];
			const otherChildren = children.slice(1);

			// handle click of first child
			const firstChildCheckbox = firstChild.querySelector('input[type="checkbox"]');
			if (firstChildCheckbox) {
				firstChildCheckbox.addEventListener('change', function () {
					const firstChildChecked = this.checked;

					otherChildren.forEach(child => {
						const cb = child.querySelector('input[type="checkbox"]');
						if (cb) {
							cb.checked = firstChildChecked;
						}
					});
				});
			}

			// handle click of the other children
			otherChildren.forEach(child => {
				const cb = child.querySelector('input[type="checkbox"]');
				if (cb) {
					cb.addEventListener('change', function () {
						const firstChildCheckbox = firstChild.querySelector('input[type="checkbox"]');
						const allOtherChecked = otherChildren.every(child => {
							const cb = child.querySelector('input[type="checkbox"]');
							return cb && cb.checked;
						});

						firstChildCheckbox.checked = allOtherChecked;
					});
				}
			});
		});
	});

	/* 15. Functions */

	/**
	 * Scrolls to an anchor.
	 * @param {string} anchor - id attribute of the anchor element (e.g. "#some-headline").
	 * @param {number} distance - distance / offset for the target scroll position.
	 */
	function anchor_scroll(anchor, distance = 0) {
		// find anchor element
		let element;
		element = document.querySelector(anchor);

		if (!element) {
			// could not find anchor element
			return false;
		}

		// calculate scroll position to anchor
		const rect = element.getBoundingClientRect();
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		const style = window.getComputedStyle(element);
		const marginTop = parseFloat(style.marginTop) || 0;
		const top = rect.top + scrollTop - marginTop;

		// animate the scroll
		jQuery('html, body').animate({
			scrollTop: top - distance
		}, 500);

		return false;
	}

	function multiSelectCheck(selections, multi, button) {

		const multiCheck = () => {
			let isChecked = true;
			selections.forEach((selection) => {
				if (!selection.checked) {
					isChecked = false;
					return false;
				}
			});
			return isChecked;
		}

		multi.checked = multiCheck();
		selectedElements(multi, button, true);

		if (multiCheck() === false) {
			selections.forEach((selection) => {
				if (selection.checked) {
					selectedElements(selection, button);
				}
			});
		}
	}

	function selectedElements(selected, button, dropAll = false) {

		let selectedTitle = selected.dataset.title;
		let buttonLabel = button.children[0];
		let buttonList = button.children[1];
		let listElement = document.createElement('span');

		listElement.classList.add('multi-selected-title');
		listElement.setAttribute('title', selectedTitle);
		listElement.textContent = selectedTitle;

		if (dropAll === true) {
			buttonList.replaceChildren();
		}

		if (selected.getAttribute('type') === 'radio') {
			if (selected.checked) {
				buttonLabel.style.display = 'none';
				buttonList.appendChild(listElement);
			} else {
				buttonList.replaceChildren();
			}
		} else {
			let selectedItem = buttonList.querySelector('span.multi-selected-title[title="' + selectedTitle + '"]')
			if (selectedItem !== null) {
				selectedItem.remove();
			}
			if (selected.checked) {
				buttonList.appendChild(listElement);
				buttonLabel.style.display = 'none';
			}
		}
		if (!buttonList.hasChildNodes()) {
			buttonLabel.style.display = 'block';
		}

	}

	function iframeSizing(iframeID) {

		if(iframeID !== '') {
			jQuery(iframeID).iFrameResize({
				checkOrigin : false,
				heightCalculationMethod : 'bodyOffset',
				onResized: function(event) {
					if(event.type === 'imageLoad') {
						anchor_scroll('#rental-contact', 150);
					}
				}
			});
		}

	}
})();
